module.exports = __webpack_public_path__ + "static/media/alpha.fd53c6e4.png";